export const rowType = {
    Header: 0,
    Content: 1,
}

export const columnType = {
    DAY: 0,
    PART: 1,
    AdditionalInfo: 2,
    KO: 3,
    EN: 4,
    JA: 5,
    ZH: 6,
    TH: 7,
    VN: 8,
    MN: 9,
    ID: 10,
    RU: 11,
    TW: 12,

}

export const oddDayModel = {
    listening: {
        listeningContent: {
            step: 0,
            day: 0,
            languageCode: '',
            text: ''
        },
        voiceType: '',
        multiTranslates: [],
    },
    listening1: '',
    listening2: '',
    listening3:
        {
            content: '',
            voiceType: ''
        },
    sentence: '',
    hearing: '',

    step: 0,
    day: 0,
    languageCode: '',
    allPartsWritten: false,
    mainContentExist: false,
}

export const listeningContentModel = {
    listeningContent: {
        step: 0,
        day: 0,
        languageCode: '',
        text: ''
    },
    voiceType: '',
}


export const evenDayModel = {
    reqDialogues: [],
    writingQuizContent: {},
    reqWritings: [],
    reqSpeakings: [],
    step: 0,
    day: 0,
    languageCode: '',
    mainContentExist: false,
    allPartsWritten: false,
}

export const dialogueModel = {
    dialogue: {
        step: 0,
        day: 0,
        languageCode: '',
        text: '',
        sequence: 0,
        speakerName: ''
    },
    voiceType: '',
    multiTranslates: []

}
export const reqWritingQuizContent = {
    step: 0,
    day: 0,
    languageCode: '',
    leftWord: '',
    rightWord: '',
    keyword: false,
}
export const reqWriting = {
    writingContent: {
        step: 0,
        day: 0,
        languageCode: '',
        sequence: 0,
        word: '',
    },
    description: '',
    voiceType: '',
    multiTranslates: []

}
export const speakingModel = {
    speakingContent: {
        step: 0,
        day: 0,
        languageCode: '',
        sequence: 0,
        text: '',
    },
    voiceType: '',
    multiTranslates: []
}
